import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card } from '@/components/ui/card';
import { toast } from 'sonner';

export default function LoginPage() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await login(email, password);
      toast.success('Login realizado com sucesso!');
      navigate('/dashboard');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Erro ao fazer login');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex">
      {/* Left side - Brand Biotop Supplements */}
      <div className="hidden lg:flex lg:w-1/2 p-12 flex-col justify-center items-center relative overflow-hidden" style={{ background: 'linear-gradient(135deg, #065f46 0%, #064e3b 40%, #022c22 100%)' }}>
        <div className="absolute inset-0 opacity-10" style={{ backgroundImage: 'radial-gradient(circle at 30% 50%, rgba(255,255,255,0.1) 0%, transparent 50%)', }} />
        <div className="relative z-10 flex flex-col items-center text-center">
          <div className="w-44 h-44 rounded-2xl bg-white flex items-center justify-center mb-8 shadow-2xl p-4">
            <img
              src="https://customer-assets.emergentagent.com/job_bonavita-novo/artifacts/77x2xbm3_logo_bio-top-suplementos-naturais_M0lZxH.png"
              alt="Biotop Supplements"
              className="w-full h-full object-contain"
            />
          </div>
          <h1 className="text-5xl font-bold text-white mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
            Biotop
          </h1>
          <p className="text-emerald-200 text-xl tracking-widest uppercase" style={{ fontFamily: 'Plus Jakarta Sans, sans-serif', letterSpacing: '0.25em' }}>
            Supplements
          </p>
          <div className="mt-12 space-y-4 text-white/80 text-left max-w-sm">
            <div className="flex items-start gap-3">
              <div className="w-2 h-2 rounded-full bg-emerald-400 mt-2 shrink-0" />
              <p>Gestao completa de leads e vendas</p>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-2 h-2 rounded-full bg-emerald-400 mt-2 shrink-0" />
              <p>Reengajamento automatizado via WhatsApp</p>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-2 h-2 rounded-full bg-emerald-400 mt-2 shrink-0" />
              <p>Disparo em massa com personalização</p>
            </div>
          </div>
        </div>
      </div>

      {/* Right side - Login Form */}
      <div className="flex-1 flex items-center justify-center p-8 bg-gradient-to-br from-slate-50 via-white to-emerald-50/30">
        <Card className="w-full max-w-md p-8 shadow-lg">
          <div className="mb-8 flex flex-col items-center">
            <div className="w-20 h-20 rounded-xl bg-white border border-emerald-100 flex items-center justify-center mb-4 lg:hidden p-2">
              <img
                src="https://customer-assets.emergentagent.com/job_bonavita-novo/artifacts/77x2xbm3_logo_bio-top-suplementos-naturais_M0lZxH.png"
                alt="Biotop"
                className="w-full h-full object-contain"
              />
            </div>
            <h2 className="text-3xl font-bold text-slate-900 mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>
              Bem-vindo
            </h2>
            <p className="text-slate-600" style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
              Faca login para acessar o sistema
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6" data-testid="login-form">
            <div className="space-y-2">
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                type="email"
                placeholder="seu@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                data-testid="email-input"
              />
            </div>

            <div className="space-y-2">
              <Label htmlFor="password">Senha</Label>
              <Input
                id="password"
                type="password"
                placeholder="........"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                data-testid="password-input"
              />
            </div>

            <Button
              type="submit"
              className="w-full text-white bg-emerald-600 hover:bg-emerald-700"
              disabled={loading}
              data-testid="login-button"
            >
              {loading ? 'Entrando...' : 'Entrar'}
            </Button>
          </form>

          <div className="mt-6 text-center">
            <p className="text-sm text-slate-600">
              Nao tem uma conta?{' '}
              <Link to="/register" className="text-emerald-700 hover:text-emerald-800 font-medium">
                Cadastre-se
              </Link>
            </p>
          </div>
        </Card>
      </div>
    </div>
  );
}
